// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `a.link[data-v-79b73110]{text-decoration:underline;color:var(--color-primary-element-light)}`, "",{"version":3,"sources":["webpack://./src/components/SubscriptionListItem.vue"],"names":[],"mappings":"AACA,wBACC,yBAAA,CACA,wCAAA","sourcesContent":["\na.link {\n\ttext-decoration: underline;\n\tcolor: var(--color-primary-element-light);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
